import { render, staticRenderFns } from "./rectificationDetails.vue?vue&type=template&id=7b0348a8&scoped=true"
import script from "./rectificationDetails.vue?vue&type=script&lang=js"
export * from "./rectificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0348a8",
  null
  
)

export default component.exports